import { render, staticRenderFns } from "./connect-pic.vue?vue&type=template&id=30d8e2b2&scoped=true&"
import script from "./connect-pic.vue?vue&type=script&lang=js&"
export * from "./connect-pic.vue?vue&type=script&lang=js&"
import style0 from "./connect-pic.vue?vue&type=style&index=0&id=30d8e2b2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d8e2b2",
  null
  
)

export default component.exports